import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { MenuItem } from '@germix/germix-react-core';
import { NavbarMenuButton } from '@germix/germix-react-navbar';
import getLanguageIcon from '../../utils/language/getLanguageIcon';
import { AVAILABLE_LANGS } from '../../utils/language/isAvailableLanguage';

interface Props extends WithTranslation
{
}
interface State
{
}

/**
 * @author Germán Martínez
 */
class LanguageNavbarMenuButton extends React.Component<Props, State>
{
    state =
    {
        menuOpen: false,
    }
    render()
    {
        return (
<>
    <NavbarMenuButton image={getLanguageIcon(this.props.i18n.language)}>

        { AVAILABLE_LANGS.map((lang) =>
        {
            return <MenuItem key={lang.code} label={lang.label} image={getLanguageIcon(lang.code)} onClick={() => { this.changeLanguage(lang.code) }}/>
        })}

    </NavbarMenuButton>
</>
        );
    }

    changeLanguage = (lang) =>
    {
        this.props.i18n.changeLanguage(lang);
        localStorage.setItem('language', lang);
    }
};
export default withTranslation()(LanguageNavbarMenuButton);
